export default __webpack_public_path__ + "assets/24a6554a0becae2d4ce9346b73ba4e17.png";